
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/ambassadors/[slug]",
      function () {
        return require("private-next-pages/[locale]/ambassadors/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/ambassadors/[slug]"])
      });
    }
  